const state = {
    app: {
        title: "Stack NG",
        subTitle: "",
        menuOpen: false,
        showHeader: true,
        activityBarOpen: false,
        storyModal: {
            show: false,
            story: null,
            nextStory: null,
            prevStory: null,
            users: null
        },
        accountModal: {
            show: false,
            action: ""
        },
        groupsModal: {
            show: false,
            searchableUsers: [],
            from: "",
            group: null
        },
        unfollowModal: {
            show: false,
            user: {}
        },
        imageModal: {
            show: false,
            image: ""
        },
        imageUploadModal: {
            show: false
        },
        notificationsModal: {
            show: false,
            notifications: []
        },
        apiError: null
    },
    mobileSearchActive: false
};

const getters = {
    mobileSearch: state => {
        return state.mobileSearchActive;
    },
    getStoryModal: state => {
        return state.app.storyModal;
    },
    getAccountModal: state => {
        return state.app.accountModal;
    },
    getUnfollowModal: state => {
        return state.app.unfollowModal;
    },
    getGroupsModal: state => {
        return state.app.groupsModal;
    }
};

const mutations = {
    updateAppSubtitle: (state, subTitle) => {
        state.app.subTitle = subTitle;
    },
    updateMobileSearch: (state, payload) => {
        state.mobileSearchActive = payload;
    },
    updateStoryModal: (state, payload) => {
        state.app.storyModal.show = payload.show;
        state.app.storyModal.users = payload.users;
        state.app.storyModal.story = payload.story;
        state.app.storyModal.nextStory = payload.nextStory;
        state.app.storyModal.prevStory = payload.prevStory;
    },
    updateAccountModal: (state, payload) => {
        state.app.accountModal.show = payload.show;
        state.app.accountModal.action = payload.action;
    },
    updateUnfollowModal: (state, payload) => {
        state.app.unfollowModal.show = payload.show;
        state.app.unfollowModal.user = payload.user;
    },
    updateGroupsModal: (state, payload) => {
        state.app.groupsModal.show = payload.show || state.app.groupsModal.show;
        state.app.groupsModal.group =
            payload.group || state.app.groupsModal.group;
        state.app.groupsModal.from = payload.from || state.app.groupsModal.from;
        state.app.groupsModal.searchableUsers =
            payload.searchableUsers || state.app.groupsModal.searchableUsers;
    },
    updateImageModal: (state, payload) => {
        state.app.imageModal.show = payload.show;
        state.app.imageModal.username = payload.username;
        state.app.imageModal.image = payload.image;
    },
    updateImageUploadModal: (state, payload) => {
        state.app.imageUploadModal.show = payload.show;
    },
    updateNotificationsModal: (state, payload) => {
        state.app.notificationsModal.show = payload;
    },
    signOut: state => {
        state.app.menuOpen = false;
    }
};

const actions = {
    updateMobileSearch: ({ commit }, payload) => {
        commit("updateMobileSearch", payload);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js